import React from 'react';
export var Footer = function Footer(_ref) {
  var renderPrice = _ref.renderPrice,
    price = _ref.price,
    priceError = _ref.priceError,
    actionBar = _ref.actionBar,
    className = _ref.className,
    withPriceBlock = _ref.withPriceBlock;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "SubscriptionCard-Footer"
  }, withPriceBlock && (renderPrice ? price : priceError), actionBar);
};